import { ReactNode } from 'react';

type AppLayoutProps = {
  sidebar: ReactNode;
  topbar: ReactNode;
  children: ReactNode;
};

export default function AppLayout({ sidebar, topbar, children }: AppLayoutProps) {
  return (
    <div className="portal-root">
      {sidebar}
      <div className="portal-workspace">
        {topbar}
        {children}
      </div>
    </div>
  );
}
